// Sample document data for demonstration
const documentData = [
    {
      id: "doc1",
      title: "Energy Communities Guidelines 2023",
      type: "pdf",
      uploadDate: "2023-11-10",
      uploadedBy: "maxmu",
      size: "2.4 MB",
      category: "Guidelines",
      url: "#",
      thumbnail:
        "https://cdn.builder.io/api/v1/image/assets/TEMP/placeholder-pdf?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0",
      description:
        "Official guidelines for establishing and managing energy communities in 2023.",
    },
    {
      id: "doc2",
      title: "Solar Panel Installation Manual",
      type: "docx",
      uploadDate: "2023-10-25",
      uploadedBy: "solarFan",
      size: "1.8 MB",
      category: "Manuals",
      url: "#",
      thumbnail:
        "https://cdn.builder.io/api/v1/image/assets/TEMP/placeholder-docx?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0",
      description: "Step-by-step guide for installing residential solar panels.",
    },
    {
      id: "doc3",
      title: "Community Energy Project Proposal Template",
      type: "docx",
      uploadDate: "2023-11-05",
      uploadedBy: "communityLead",
      size: "950 KB",
      category: "Templates",
      url: "#",
      thumbnail:
        "https://cdn.builder.io/api/v1/image/assets/TEMP/placeholder-docx?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0",
      description:
        "Template for creating comprehensive energy project proposals.",
    },
    {
      id: "doc4",
      title: "Energy Efficiency Data Analysis",
      type: "xlsx",
      uploadDate: "2023-10-18",
      uploadedBy: "dataAnalyst",
      size: "3.2 MB",
      category: "Research",
      url: "#",
      thumbnail:
        "https://cdn.builder.io/api/v1/image/assets/TEMP/placeholder-xlsx?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0",
      description:
        "Spreadsheet with comprehensive energy efficiency data and analysis.",
    },
    {
      id: "doc5",
      title: "Wind Turbine Comparison Study",
      type: "pdf",
      uploadDate: "2023-11-12",
      uploadedBy: "windExpert",
      size: "4.7 MB",
      category: "Research",
      url: "#",
      thumbnail:
        "https://cdn.builder.io/api/v1/image/assets/TEMP/placeholder-pdf?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0",
      description:
        "Comparative study of different wind turbine models for community use.",
    },
    {
      id: "doc6",
      title: "Community Energy Funding Sources",
      type: "gdrive",
      uploadDate: "2023-10-30",
      uploadedBy: "grantSeeker",
      size: "Online",
      category: "Resources",
      url: "https://drive.google.com/file/example",
      thumbnail:
        "https://cdn.builder.io/api/v1/image/assets/TEMP/placeholder-gdrive?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0",
      description:
        "Comprehensive list of funding sources for community energy projects.",
    },
    {
      id: "doc7",
      title: "Energy Community Legal Framework",
      type: "pdf",
      uploadDate: "2023-11-08",
      uploadedBy: "legalEagle",
      size: "5.1 MB",
      category: "Legal",
      url: "#",
      thumbnail:
        "https://cdn.builder.io/api/v1/image/assets/TEMP/placeholder-pdf?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0",
      description: "Legal framework and regulations for energy communities.",
    },
    {
      id: "doc8",
      title: "Hydropower System Specifications",
      type: "pdf",
      uploadDate: "2023-10-22",
      uploadedBy: "hydroEngineer",
      size: "3.8 MB",
      category: "Technical",
      url: "#",
      thumbnail:
        "https://cdn.builder.io/api/v1/image/assets/TEMP/placeholder-pdf?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0",
      description: "Technical specifications for small-scale hydropower systems.",
    },
    {
      id: "doc9",
      title: "Energy Community Meeting Minutes",
      type: "docx",
      uploadDate: "2023-11-15",
      uploadedBy: "communityLead",
      size: "780 KB",
      category: "Administrative",
      url: "#",
      thumbnail:
        "https://cdn.builder.io/api/v1/image/assets/TEMP/placeholder-docx?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0",
      description: "Minutes from the latest energy community meeting.",
    },
    {
      id: "doc10",
      title: "Solar Energy ROI Calculator",
      type: "xlsx",
      uploadDate: "2023-11-01",
      uploadedBy: "financialAdvisor",
      size: "1.2 MB",
      category: "Financial",
      url: "#",
      thumbnail:
        "https://cdn.builder.io/api/v1/image/assets/TEMP/placeholder-xlsx?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0",
      description:
        "Calculator for determining return on investment for solar energy projects.",
    },
    {
      id: "doc11",
      title: "Community Energy Project Timeline",
      type: "gdrive",
      uploadDate: "2023-10-28",
      uploadedBy: "projectManager",
      size: "Online",
      category: "Project Management",
      url: "https://drive.google.com/file/example2",
      thumbnail:
        "https://cdn.builder.io/api/v1/image/assets/TEMP/placeholder-gdrive?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0",
      description:
        "Project timeline and milestones for community energy implementation.",
    },
    {
      id: "doc12",
      title: "Energy Storage Solutions Presentation",
      type: "pptx",
      uploadDate: "2023-11-07",
      uploadedBy: "storageExpert",
      size: "6.3 MB",
      category: "Presentations",
      url: "#",
      thumbnail:
        "https://cdn.builder.io/api/v1/image/assets/TEMP/placeholder-pptx?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0",
      description:
        "Presentation on various energy storage solutions for communities.",
    },
  ];
  
  export default documentData;
  